import axios from 'axios'
import { Loading, Message, Notification } from 'element-ui'
import { getToken } from '../utils/cookies'
import store from '../store/index'
import { getSignStr } from './tools'
console.log(process.env.NODE_ENV)
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_2,
    timeout: 10000
});

let loading = null

/*
    请求拦截器
    noAuth: true              - 不用传token;
    loading: true             - 请求接口时显示loading图标
    loadingText: '加载中...'   - 请求接口时等待时显示的文字
*/
instance.interceptors.request.use(function (config) {
    // console.log('before', config)
    // 在发送请求之前做些什么
    // config.headers['Content-Type'] = 'application/json'
    if (!config.noAuth && getToken()) {
        config.data['user_token'] = getToken()
    }
    let sign = getSignStr(config.data)
    config.data['sign'] = sign
    if (config.loading) {
        // loading 图标
        loading = Loading.service({
            lock: true,
            text: config.loadingText || '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
    console.log('after', config)

    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

/*
    响应拦截器
*/
instance.interceptors.response.use(function (response) {
    // console.log('before', response)
    if (loading) {
        loading.close()
    }
    // 对响应数据做点什么
    if (response.data.errorCode == -10001) {  // token失效，错误
        Notification.error({
            title: '登录过期',
            message: '您的登录信息已过期， 请重新登录',
            duration: 2500
        })
        store.dispatch('logOut', 2)
    }
    return response.data
}, function (error) {
    console.log('error', error)
    if (loading) {
        loading.close()
    }
    Message({
        message: '系统异常',
        type: 'error'
    })
    // 对响应错误做点什么
    return Promise.reject(error);
})

export default instance
